import { designTokensPlugin, OlScrollbarDirective, OlTokens } from '@gamesite/game-core'
import helpers from 'boot/helpers'
import vClickOutside from 'click-outside-vue3'
import dragscroll from 'vue-dragscroll'
import { createVfm } from 'vue-final-modal'
import VueLazyLoad from 'vue3-lazyload'
import { Vue3Mq } from 'vue3-mq'
import { getInitialTheme, initLayoutThemeSync } from 'src/common/composition/useLayoutTheme.js'
import { getConfig } from 'src/configs/index.js'

const config = getConfig()

export default ({ app }) => {
  app.use(Vue3Mq, {
    preset: 'tailwind',
  })
  app.use(helpers)
  app.use(vClickOutside)
  app.use(designTokensPlugin, {
    autoInject: true,
    initialTheme: getInitialTheme(config),
    enableResponsive: true,
  })
  app.use(VueLazyLoad, {
    preLoad: 1.1,
    attempt: 1,
    lazyComponent: true,
  })
  app.directive('dragscroll', dragscroll)
  app.directive('ol-scrollbar', OlScrollbarDirective)
  app.directive('tokens', OlTokens)

  const vfm = createVfm()
  app.use(vfm)

  return initLayoutThemeSync(app, config)
}
